import { createAction } from 'redux-actions';

const actions = {
  /**
   *  태그 데이터 변경하기
   */
  SET_DATA: 'tag/SET_DATA',
  setData: createAction('tag/SET_DATA'),

  /**
   * 태그 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_INSERT_TAG_REQUEST: 'tag/PREPARE_INSERT_TAG_REQUEST',
  PREPARE_INSERT_TAG_SUCCESS: 'tag/PREPARE_INSERT_TAG_SUCCESS',
  prepareInsertTag: createAction('tag/PREPARE_INSERT_TAG_REQUEST'),

  /**
   *  태그명 중복검사 요청하기
   */
  CHECK_TAG_NAME_REQUEST: 'tag/CHECK_TAG_NAME_REQUEST',
  CHECK_TAG_NAME_SUCCESS: 'tag/CHECK_TAG_NAME_SUCCESS',
  checkTagName: createAction('tag/CHECK_TAG_NAME_REQUEST'),

  /**
   *  태그 검색 리스트 요청하기
   */
  GET_TAG_SEARCH_LIST_REQUEST: 'tag/GET_TAG_SEARCH_LIST_REQUEST',
  GET_TAG_SEARCH_LIST_SUCCESS: 'tag/GET_TAG_SEARCH_LIST_SUCCESS',
  getTagSearchList: createAction('tag/GET_TAG_SEARCH_LIST_REQUEST'),

  /**
   *  추천 태그 리스트 요청하기
   */
  GET_RECOMMEND_TAG_LIST_REQUEST: 'tag/GET_RECOMMEND_TAG_LIST_REQUEST',
  GET_RECOMMEND_TAG_LIST_SUCCESS: 'tag/GET_RECOMMEND_TAG_LIST_SUCCESS',
  getRecommendTagList: createAction('tag/GET_RECOMMEND_TAG_LIST_REQUEST'),

  /**
   *  태그에 연결할 아이템 리스트 요청하기
   */
  GET_TAG_RELATED_ITEM_LIST_REQUEST: 'tag/GET_TAG_RELATED_ITEM_LIST_REQUEST',
  GET_TAG_RELATED_ITEM_LIST_SUCCESS: 'tag/GET_TAG_RELATED_ITEM_LIST_SUCCESS',
  getTagRelatedItemList: createAction('tag/GET_TAG_RELATED_ITEM_LIST_REQUEST'),

  /**
   *  태그 상세 미리보기 데이터 요청히기
   */
  GET_TAG_DETAIL_PREVIEW_DATA_REQUEST: 'tag/GET_TAG_DETAIL_PREVIEW_DATA_REQUEST',
  getTagDetailPreviewData: createAction('tag/GET_TAG_DETAIL_PREVIEW_DATA_REQUEST'),

  /**
   *  태그 등록 요청하기
   */
  INSERT_TAG_REQUEST: 'tag/INSERT_TAG_REQUEST',
  insertTag: createAction('tag/INSERT_TAG_REQUEST'),

  /**
   *  태그 편집 요청하기
   */
  EDIT_TAG_REQUEST: 'tag/EDIT_TAG_REQUEST',
  editTag: createAction('tag/EDIT_TAG_REQUEST'),

  /**
   *  태그 리스트 요청하기
   */
  GET_TAG_LIST_REQUEST: 'tag/GET_TAG_LIST_REQUEST',
  GET_TAG_LIST_SUCCESS: 'tag/GET_TAG_LIST_SUCCESS',
  getTagList: createAction('tag/GET_TAG_LIST_REQUEST'),

  /**
   *  태그 상세 내역 요청하기
   */
  GET_TAG_HISTORY_LIST_REQUEST: 'tag/GET_TAG_HISTORY_LIST_REQUEST',
  GET_TAG_HISTORY_LIST_SUCCESS: 'tag/GET_TAG_HISTORY_LIST_SUCCESS',
  getTagHistory: createAction('tag/GET_TAG_HISTORY_LIST_REQUEST'),

  /**
   *  태그 상세 내역에 연결된 아이템 리스트 요청하기
   */
  GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST: 'tag/GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST',
  GET_TAG_HISTORY_RELATED_ITEM_LIST_SUCCESS: 'tag/GET_TAG_HISTORY_RELATED_ITEM_LIST_SUCCESS',
  getTagHistoryRelatedItemList: createAction('tag/GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST'),

  /**
   *  태그 그룹명 중복검사 요청하기
   */
  CHECK_TAG_GROUP_NAME_REQUEST: 'tag/CHECK_TAG_GROUP_NAME_REQUEST',
  CHECK_TAG_GROUP_NAME_SUCCESS: 'tag/CHECK_TAG_GROUP_NAME_SUCCESS',
  checkTagGroupName: createAction('tag/CHECK_TAG_GROUP_NAME_REQUEST'),

  /**
   *  태그에 그룹 연결할 아이템 리스트 요청하기
   */
  GET_TAG_GROUP_ITEM_LIST_REQUEST: 'tag/GET_TAG_GROUP_ITEM_LIST_REQUEST',
  GET_TAG_GROUP_ITEM_LIST_SUCCESS: 'tag/GET_TAG_GROUP_ITEM_LIST_SUCCESS',
  getTagGroupItemList: createAction('tag/GET_TAG_GROUP_ITEM_LIST_REQUEST'),

  /**
   *  태그 그룹 등록 요청하기
   */
  INSERT_TAG_GROUP_REQUEST: 'tag/INSERT_TAG_GROUP_REQUEST',
  insertTagGroup: createAction('tag/INSERT_TAG_GROUP_REQUEST'),

  /**
   *  태그 그룹 리스트 요청하기
   */
  GET_TAG_GROUP_LIST_REQUEST: 'tag/GET_TAG_GROUP_LIST_REQUEST',
  GET_TAG_GROUP_LIST_SUCCESS: 'tag/GET_TAG_GROUP_LIST_SUCCESS',
  getTagGroupList: createAction('tag/GET_TAG_GROUP_LIST_REQUEST'),

  /**
   *  태그 그룹 상세 데이터 요청하기
   */
  GET_TAG_GROUP_DETAIL_REQUEST: 'tag/GET_TAG_GROUP_DETAIL_REQUEST',
  GET_TAG_GROUP_DETAIL_SUCCESS: 'tag/GET_TAG_GROUP_DETAIL_SUCCESS',
  getTagGroupDetail: createAction('tag/GET_TAG_GROUP_DETAIL_REQUEST'),

  /**
   *  태그 상세 요청하기
   */
  GET_TAG_DETAIL_REQUEST: 'tag/GET_TAG_DETAIL_REQUEST',
  GET_TAG_DETAIL_SUCCESS: 'tag/GET_TAG_DETAIL_SUCCESS',
  getTagDetail: createAction('tag/GET_TAG_DETAIL_REQUEST'),

  /**
   *  태그 그룹 편집 요청하기
   */
  EDIT_TAG_GROUP_REQUEST: 'tag/EDIT_TAG_GROUP_REQUEST',
  editTagGroup: createAction('tag/EDIT_TAG_GROUP_REQUEST'),

  /**
   *  태그 등록 거절 요청하기
   */
  REJECT_REGISTRATION_TAG_REQUEST: 'tag/REJECT_REGISTRATION_TAG_REQUEST',
  rejectRegistrationTag: createAction('tag/REJECT_REGISTRATION_TAG_REQUEST'),

  /**
   *  태그 탭 메인 데이터 요청하기
   */
  GET_TAG_TAB_MAIN_DATA_REQUEST: 'tag/GET_TAG_TAB_MAIN_DATA_REQUEST',
  GET_TAG_TAB_MAIN_DATA_SUCCESS: 'tag/GET_TAG_TAB_MAIN_DATA_SUCCESS',
  getTagTabMainData: createAction('tag/GET_TAG_TAB_MAIN_DATA_REQUEST'),

  /**
   *  태그 탭 메인에 연결할 컨텐츠 리스트 요청하기
   */
  GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST: 'tag/GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST',
  GET_TAG_TAB_MAIN_CONTENTS_LIST_SUCCESS: 'tag/GET_TAG_TAB_MAIN_CONTENTS_LIST_SUCCESS',
  getTagTabMainContentsList: createAction('tag/GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST'),

  /**
   *  태그 탭 메인 미리보기 데이터 요청히기
   */
  GET_TAG_TAB_MAIN_PREVIEW_DATA_REQUEST: 'tag/GET_TAG_TAB_MAIN_PREVIEW_DATA_REQUEST',
  getTagTabMainPreviewData: createAction('tag/GET_TAG_TAB_MAIN_PREVIEW_DATA_REQUEST'),

  /**
   *  태그 탭 메인 편집 요청하기
   */
  EDIT_TAG_TAB_MAIN_REQUEST: 'tag/EDIT_TAG_TAB_MAIN_REQUEST',
  editTagTabMain: createAction('tag/EDIT_TAG_TAB_MAIN_REQUEST'),

  /**
   *  태그 트렌드 키워드 데이터 요청하기
   */
  GET_TREND_KEYWORD_DATA_REQUEST: 'tag/GET_TREND_KEYWORD_DATA_REQUEST',
  GET_TREND_KEYWORD_DATA_SUCCESS: 'tag/GET_TREND_KEYWORD_DATA_SUCCESS',
  getTagTrendKeywordData: createAction('tag/GET_TREND_KEYWORD_DATA_REQUEST'),

  /**
   *  태그 트렌드 키워드에 연결할 컨텐츠 리스트 요청하기
   */
  GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST: 'tag/GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST',
  GET_TAG_TREND_KEYWORD_CONTENTS_LIST_SUCCESS: 'tag/GET_TAG_TREND_KEYWORD_CONTENTS_LIST_SUCCESS',
  getTagTrendKeywordContentsList: createAction('tag/GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST'),

  /**
   *  태그 트렌드 키워드 미리보기 데이터 요청히기
   */
  GET_TAG_TREND_KEYWORD_PREVIEW_DATA_REQUEST: 'tag/GET_TAG_TREND_KEYWORD_PREVIEW_DATA_REQUEST',
  getTagTrendKeywordPreviewData: createAction('tag/GET_TAG_TREND_KEYWORD_PREVIEW_DATA_REQUEST'),

  /**
   *  태그 트렌드 키워드 편집 요청하기
   */
  EDIT_TAG_TREND_KEYWORD_REQUEST: 'tag/EDIT_TAG_TREND_KEYWORD_REQUEST',
  editTagTrendKeyword: createAction('tag/EDIT_TAG_TREND_KEYWORD_REQUEST'),

  /**
   *  [태그 그룹 등록/편집] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_GROUP_ALL_LIST_EXCEL_DOWNLOAD_REQUEST: 'tag/GET_TAG_GROUP_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getTagGroupAllListExcelDownload: createAction('tag/GET_TAG_GROUP_ALL_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [태그 메인 탭 관리] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_TAB_MAIN_ALL_LIST_EXCEL_DOWNLOAD_REQUEST: 'tag/GET_TAG_TAB_MAIN_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getTagTabMainAllListExcelDownload: createAction('tag/GET_TAG_TAB_MAIN_ALL_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [태그 트렌드 키워드 관리] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_TREND_KEYWORD_ALL_LIST_EXCEL_DOWNLOAD_REQUEST: 'tag/GET_TAG_TREND_KEYWORD_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getTagTrendKeywordAllListExcelDownload: createAction('tag/GET_TAG_TREND_KEYWORD_ALL_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [태그 그룹 등록/편집] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_GROUP_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST: 'tag/GET_TAG_GROUP_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getTagGroupSelectedListExcelDownload: createAction('tag/GET_TAG_GROUP_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [태그 메인 탭 관리] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_TAB_MAIN_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST: 'tag/GET_TAG_TAB_MAIN_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getTagTabMainSelectedListExcelDownload: createAction('tag/GET_TAG_TAB_MAIN_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [태그 트렌드 키워드 관리] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_TREND_KEYWORD_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST:
    'tag/GET_TAG_TREND_KEYWORD_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getTagTrendKeywordSelectedListExcelDownload: createAction(
    'tag/GET_TAG_TREND_KEYWORD_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [태그 그룹 등록/편집] 태그 엑셀 업로드
   */
  SET_TAG_GROUP_EXCEL_UPLOAD_REQUEST: 'tag/SET_TAG_GROUP_EXCEL_UPLOAD_REQUEST',
  SET_TAG_GROUP_EXCEL_UPLOAD_SUCCESS: 'tag/SET_TAG_GROUP_EXCEL_UPLOAD_SUCCESS',
  setTagGroupExcelUpload: createAction('tag/SET_TAG_GROUP_EXCEL_UPLOAD_REQUEST'),

  /**
   *  [태그 메인 탭 관리] 태그 엑셀 업로드
   */
  SET_TAG_TAB_MAIN_EXCEL_UPLOAD_REQUEST: 'tag/SET_TAG_TAB_MAIN_EXCEL_UPLOAD_REQUEST',
  SET_TAG_TAB_MAIN_EXCEL_UPLOAD_SUCCESS: 'tag/SET_TAG_TAB_MAIN_EXCEL_UPLOAD_SUCCESS',
  setTagTabMainExcelUpload: createAction('tag/SET_TAG_TAB_MAIN_EXCEL_UPLOAD_REQUEST'),

  /**
   * [태그 트렌드 키워드 관리] 태그 엑셀 업로드
   */
  SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_REQUEST: 'tag/SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_REQUEST',
  SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_SUCCESS: 'tag/SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_SUCCESS',
  setTagTrendKeywordExcelUpload: createAction('tag/SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_REQUEST'),

  /**
   *  [태그 리스트] 엑셀 다운로드
   */
  GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST: 'tag/GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST',
  getTagListExcelDownload: createAction('tag/GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'update/TOGGLE_MODAL',
  toggleModal: createAction('update/TOGGLE_MODAL'),
};

export default actions;
